// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-tsx": () => import("/usr/src/app/src/templates/Page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */),
  "component---src-templates-page-not-found-tsx": () => import("/usr/src/app/src/templates/PageNotFound.tsx" /* webpackChunkName: "component---src-templates-page-not-found-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/usr/src/app/.cache/data.json")

